import { Table, TableHead, TableRow, TableBody, Grid } from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { useState, useEffect, useRef } from "react";//FB 7485
import { GetLogo } from "../../../../api";//FB 7485
import useStyles from "../../../../css/styles";
import { useReactToPrint } from "react-to-print";

// Update log
// FB  6192   02/06/2023  DK  Added page to get payment receipt
// FB  7106   07/28/2023  SK  Patient Portal : Billing screen enhancements
// FB  7469   09/27/2023  SK   Patient Portal - Replace Doctor Direct with License Name , Update logo in Payment Receipt , Change in texts in Home Page
// FB  7485   09/28/2023  SK  Print Receipt modifications in Portal
// FB  7704   10/27/2023  SK  Manually Entering Billing Amount is showing error in Print Receipt view and Update Pharmacy is failing in Portal

export default function PaymentReceipt(props) {
    const styles = useStyles();
    let id = "";
    let amount = "";
    let data = sessionStorage.getItem("Transaction");
    if (data != null) {
        id = JSON.parse(data).transID;
        amount = Number(JSON.parse(data).amount).toFixed(2);//FB 7106   //FB 7704
    }
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    // FB 7469 - Begin
    const [logoImage, setLogoImage] = useState('');//FB 7485
    const GetLogoImage = async () => {
        const logo = await GetLogo();
        setLogoImage(logo);
        setTimeout(() => {
            handlePrint();
        }, 3000);

    }

    useEffect(() => {
        GetLogoImage();
        //sessionStorage.removeItem("Transaction");
    }, []);
    // FB 7469 - End

    return (
        <Grid container spacing={3} padding="50px" ref={componentRef} >
            <Grid item xs={12} className={styles.flexcenter_Grid}>
                {/* FB 7485 */}
                <img
                    src={logoImage}
                    alt="logo"
                    style={{ display: "flex", maxWidth: "75vh" }}
                />
                {/* FB 7469 */}
            </Grid>
            <Grid item xs={12} className={styles.flexcenter_Grid}>
                <Table sx={{
                    [`& .${tableCellClasses.root}`]: {
                        borderBottom: "none"
                    }
                    , minWidth: "650px", maxWidth: "800px", border: "none"
                }}>
                    <TableHead>
                        <TableRow>
                            {/* FB 7106 - Begin */}
                            <TableCell align="right">{"Date: " + new Date().toLocaleDateString() + ""}</TableCell>
                            <TableCell>{"Time: " + new Date().toLocaleTimeString() + ""}</TableCell>
                            {/* FB 7106 - End */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {/* FB 7106 - Deleted Unused part of code and changed the alignment - Begin */}
                        <TableRow>
                            <TableCell align="right">Card Type:</TableCell>
                            <TableCell >Credit Card</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="right">Transaction ID:</TableCell>
                            <TableCell >{id}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="right">Amount:</TableCell>
                            <TableCell >${amount}</TableCell>
                        </TableRow>
                        {/* FB 7106 - End */}
                    </TableBody>
                </Table>
            </Grid>
        </Grid>
    )
}